import { render } from "./TournamentScheduleForm.vue?vue&type=template&id=7cc35772&scoped=true"
import script from "./TournamentScheduleForm.vue?vue&type=script&lang=js"
export * from "./TournamentScheduleForm.vue?vue&type=script&lang=js"

import "./TournamentScheduleForm.vue?vue&type=style&index=0&id=7cc35772&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc35772"]])

export default __exports__